import './index.css'
import ReactDOM  from 'react-dom'
// components
import App from './App'

ReactDOM.render(<App />, document.querySelector('#root'));